import React from 'react';
import { useSelector } from 'react-redux';
import TeamStatsDataContainer from './TeamStatsDataContainer';
import TeamComparison from './TeamComparison';
import PropTypes from 'prop-types';
import useTracking from '@gameday/utils/hooks/useTracking';
import { getTabsState } from './store/selectors/teamComparisonTabsSelector';
import teamComparisonDatasource from '@gameday/core/datasources/teamComparison';
import teamComparisonRequestAction from './store/actions/teamComparisonDataRequestAction';
import teamStatsSeasonAllTimeReducer from './store/reducers/teamStatsSeasonAllTime';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';

// teamStatsSeasonAllTime
initContainerData.register({
    datasources: {
        teamComparison: teamComparisonDatasource
    },
    reducers: {
        teamStatsSeasonAllTime: teamStatsSeasonAllTimeReducer
    }
});

const fetchData = () => {
    return teamComparisonRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const TeamComparisonDataContainer = ({
    types,
    contentContainer
}) => {
    const Tracking = useTracking();
    const handleTabChange = (event) => {
        const selectedIndex = parseInt(event.currentTarget.dataset.index);
        const text = event?.currentTarget?.innerText;
        const cfg = {
            componentName : ['Team Comparison', text],
            selectedIndex,
            text,
            activity: 'Tab Click'
        };

        Tracking.track.track_click(cfg);
        
    };

    const { slidesList, teamComparisonGameType, isLoading } = useSelector(getTabsState);
    const list = (typeof types !== 'undefined') ? types : slidesList;

    const slides = list.map((type) => <TeamStatsDataContainer type={type} key={type}/>);

    return <TeamComparison isLoading={ isLoading } slides={slides} teamComparisonGameType={teamComparisonGameType} handleTabChange={ handleTabChange } contentContainer={ contentContainer }/>;
};

TeamComparisonDataContainer.propTypes = {
    types: PropTypes.array
};

export default TeamComparisonDataContainer;
export { fetchData, routes };
